import React from "react";
import { styles } from "../../styles";

const CompanyField = ({ name }) => (
  <a
    style={styles.title}
    href={`#/admin/companies?filter=%7B"name"%3A"${name}"%7D&order=DESC&sort=id`}>
    {name}
  </a>
);

export default CompanyField;



// WEBPACK FOOTER //
// ./src/components/fields/CompanyField.js